// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { AccessInstance } from './types.d';

export const AccessContext = React.createContext<AccessInstance>(null);
